import SectionHub from '@/components/docs/SectionHub';

export default function Docs04MacrosAndSignalsCalendarHub() {
  return <SectionHub sectionPath="04-macros-and-signals/calendar" />;
}
